<!-- Start Application journey -->
<div class="app-journey">

    <!-- Start Screen Section -->
    <div class="screen" fxFlex="50%" fxLayoutAlign="end center">
        <img src="./assets/images/artboard.svg" width="426" height="509" alt="Artboard">
    </div>
    <!-- End Screen Section -->

    <!-- Start journey Section -->
    <div class="journey-list" fxFlex="50%">
        <a href="javascript:void(0)" mat-dialog-close>Skip</a>
        <h2>Hi, {{userData ? userData?.displayName.split(" ")[0] : ''}}</h2>
        <p>Our Platform Features</p>
        <div *ngIf="activeStep == 1">
        <h3>Build, deploy and <br> update apps with ease</h3>
        <p>vDesigner is a visual UI interface which allows users to design pixel-perfect native mobile applications through easy drag & drop actions.</p>
        <!-- Start check list -->
        <div class="check-list" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span class="icon-box icon-va-check"></span>
            <h5>Drag and Drop <span>elements on a visual interface</span></h5>
        </div>
        <div class="check-list" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span class="icon-box icon-va-check"></span>
            <h5> <span>Configure </span> end-user actions <span>to the elements</span></h5>
        </div>
        <div class="check-list" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span class="icon-box icon-va-check"></span>
            <h5>Preview <span>your designs</span></h5>
        </div>
        <div class="check-list" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span class="icon-box icon-va-check"></span>
            <h5>Save <span>and</span> publish <span>directly to Sandbox</span></h5>
        </div>
    </div>

    <div *ngIf="activeStep == 2">
        <h3>Use and manage media<br>assets for your application</h3>
        <p>Assets Manager is a smart web based virtual space dashboard that allows you to import and export multiple media file types.</p>
        <!-- Start check list -->
        <div class="check-list" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span class="icon-box icon-va-check"></span>
            <h5>Import assets <span>from the local drive</span></h5>
        </div>
        <div class="check-list" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span class="icon-box icon-va-check"></span>
            <h5> Edit the details <span>of the assets</span></h5>
        </div>
        <div class="check-list" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span class="icon-box icon-va-check"></span>
            <h5>Export assets <span>as zip file downloads</span> </h5>
        </div>
        <div class="check-list" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span class="icon-box icon-va-check"></span>
            <h5>Delete assets <span>which are not required</span> </h5>
        </div>
    </div>

    <div *ngIf="activeStep == 3">
        <h3>Ensure your brand guidelines <br> with customized themes</h3>
        <p>Using Themes & Styles, you can create a customized theme that you can also apply to one or more
          applications on vDesigner.</p>

        <!-- Start check list -->
        <div class="check-list" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span class="icon-box icon-va-check"></span>
            <h5><span>Create </span> multiple themes <span></span> for your applications </h5>
        </div>
        <div class="check-list" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span class="icon-box icon-va-check"></span>
            <h5> <span>Set the </span> color palette <span>of the themes</span></h5>
        </div>
        <div class="check-list" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span class="icon-box icon-va-check"></span>
            <h5><span>Configure the </span> typography <span>of the themes</span></h5>
        </div>
        <div class="check-list" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span class="icon-box icon-va-check"></span>
            <h5><span>Set the </span> padding & margin <span> of elements and pages</span></h5>
        </div>
    </div>

    <div *ngIf="activeStep == 4">
        <h3>Create data model hierarchies <br>  for your applications</h3>
        <p>Data Modeler enables users to discover and design data models, create relationships between
          models.</p>

        <!-- Start check list -->
        <div class="check-list" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span class="icon-box icon-va-check"></span>
            <h5><span>Create </span> data models <span> and </span> entities</h5>
        </div>
        <div class="check-list" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span class="icon-box icon-va-check"></span>
            <h5> <span>Create </span> enumerations </h5>
        </div>
        <div class="check-list" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span class="icon-box icon-va-check"></span>
            <h5>Link <span> entities to a data model </span></h5>
        </div>
        <div class="check-list" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span class="icon-box icon-va-check"></span>
            <h5><span>Link data models </span> to an application</h5>
        </div>
    </div>
        <!-- End check list -->

        <!-- Start btn & step -->
        <div class="step" fxLayoutAlign="space-between center">
            <button mat-button class="primary-cta" (click)="next()">
                Next
                <span class="icon-box icon-va-navigate-next"></span>
              </button>
            <!-- Start dot -->
            <div class="slide-dot" fxLayoutAlign="start center" fxLayoutGap="4px">
                <div class="dot" [class.active]="activeStep === 1"></div>
                <div class="dot" [class.active]="activeStep === 2"></div>
                <div class="dot" [class.active]="activeStep === 3"></div>
                <div class="dot" [class.active]="activeStep === 4"></div>
            </div>
            <!-- End dot -->
        </div>
        <!-- End btn & step -->

    </div>
    <!-- End journey Section -->


</div>
